import { render, staticRenderFns } from "./AccountSwitcherModal.vue?vue&type=template&id=44a0e5c6&scoped=true"
import script from "./AccountSwitcherModal.vue?vue&type=script&lang=js"
export * from "./AccountSwitcherModal.vue?vue&type=script&lang=js"
import style0 from "./AccountSwitcherModal.vue?vue&type=style&index=0&id=44a0e5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0e5c6",
  null
  
)

export default component.exports